import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'iw-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit {
  // inicialisacion de fecha
  public startAt: Date = new Date();
  // fecha minima para ingresar
  min: Date = new Date();
  // fecha maxima para ingresar
  max: Date = new Date(2018, 3, 25);
  // Referencia del formulario de fechas de la libreria NgPickDateTime
  formPdt: FormGroup = new FormGroup({
    date: new FormControl(this.startAt),
    timer: new FormControl(this.startAt),
    dateTimer: new FormControl(this.startAt),
    dateModal: new FormControl(this.startAt),
    timerModal: new FormControl(this.startAt),
    dateTimeModal: new FormControl(this.startAt),
    dateRange: new FormControl([this.startAt, this.startAt]),
    dateRangeModal: new FormControl([this.startAt, this.startAt]),
  });

  constructor() { }

  ngOnInit() {
    // se setea la fecha inicializada por el año, mes y dia que se quiere mostrar inicialmente
    this.startAt.setFullYear(2015);
    this.startAt.setMonth(12);
    this.startAt.setDate(25);
    // se setea la hora y minutos que se quieren mostrar inicialmente
    this.startAt.setHours(23);
    this.startAt.setMinutes(25);
  }
  // envia el formulario libreria NgPickDateTime
  SendDTP() {
    console.log(this.formPdt.value);
  }

  /**
   * Limpia el campo dentro del formulario indicado
   *
   * @param {string} nameField
   * @memberof DateComponent
   */
  emptyField(nameField: string) {
    if (!this.formPdt.controls[nameField].disabled) {
      this.formPdt.controls[nameField].setValue('');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/examples/date/date.component.ts